import CollectionList from "@/js/Shared/Collections/CollectionList";
import ContactItem    from "../Entities/ContactItem";

export { ContactsGroupSelectionCollection as default };

/**
* Contacts Modal Collection Selection
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ContactsGroupSelectionCollection extends CollectionList {

  /**
   * Contacts Collection Lists data
   *
   * @private
   *
   * @since 7.0.0
   *
   * @type {ContactsCollectionLists}
   */
  contacts;

  /**
   * Hold all group selection information
   *
   * @private
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  groups = {};

  /**
   * Constructor
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {string} index_id
   *
   * @return {void}
   */
  constructor(index_id = 'id') {
    super(index_id);
  }

  /**
   * Sets contacts collection data
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {ContactsCollectionLists} contacts
   *
   * @return {void}
   */
  setContacts(contacts) {
    this.contacts = contacts;
    this.resetGroups();
  }

  /**
   * Adds a contact to the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {ContactItem} contact
   *
   * @return {Boolean}
   */
  add(contact) {
    if (super.add(contact) === false) {
      return false;
    }

    this.addToGroups(contact);
    return true;
  }

  /**
   * Deletes a contact from the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id
   *
   * @return {Boolean}
   */
  delete(id) {
    if (super.delete(id) === false) {
      return false;
    }

    this.deleteFromGroups(id);
    return true;
  }

  /**
   * Adds or removes all group members from the list
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {ContactItem} group
   *
   * @return {void}
   */
  toggleGroup(group) {
    if (this.groups[group.id].selected_full) {
      this.deleteGroup(group);
      return;
    }

    this.addGroup(group);
  }

  /**
   * Adds all group members to the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {ContactItem} groups
   *
   * @return {void}
   */
  addGroup(group) {
    for (let id in group.members) {
      this.add(this.contacts.all.index[id]);
    }
  }

  /**
   * Delets all group members from the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {ContactItem} group
   *
   * @return {void}
   */
  deleteGroup(group) {
    for (let id in group.members) {
      this.delete(id);
    }
  }

  /**
   * Searchs all groups to figure out which groups need to be selected
   *
   * @todo PersonEntitiy needs a cache of all groups
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {ContactItem} contact
   *
   * @return {void}
   */
  addToGroups(contact) {
    this.contacts.groups.items.forEach(item => {
      if (!item.members[contact.id]) {
        return;
      }

      this.groups[item.id].count++;

      if (item.members_count === this.groups[item.id].count) {
        this.groups[item.id].selected_full = true;
        return;
      }

      this.groups[item.id].selected_half = true;
    });
  }

  /**
   * Searchs all groups to remove the selection
   * if person is in the groups.
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id
   *
   * @return {void}
   */
  deleteFromGroups(id) {
    this.contacts.groups.items.forEach(item => {
      if (!item.members[id]) {
        return;
      }

      this.groups[item.id].count--;
      this.groups[item.id].selected_full = false;

      if (this.groups[item.id].count === 0) {
        this.groups[item.id].selected_half = false;
        return;
      }
    });
  }

  /**
   * Checks if groups is fully selected
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id
   *
   * @return {Boolean}
   */
  isGroupSelectedFull(id)
  {
    return this.groups[id] && this.groups[id].selected_full;
  }

  /**
   * Checks if group is half selected
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id
   *
   * @return {Boolean}
   */
  isGroupSelectedHalf(id)
  {
    return this.groups[id] && this.groups[id].selected_half;
  }

  /**
   * Resets the collection to it's inital state
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  reset() {
    this.resetGroups();
    super.reset();
  }

  /**
   * Resets Groups Selection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  resetGroups() {
    this.contacts.groups.items.forEach(group => {
      this.groups[group.id] = {
        count         : 0,
        members       : group.members_count,
        selected_full : false,
        selected_half : false,
      }
    });
  }
}